export default __webpack_public_path__ + "static/media/TJ.03bccf7e.svg";